import React from 'react';
import { observer } from 'mobx-react-lite';
import { tableBetHistoryStore, useTranslation, useUserInfoStore } from '@pascal/pascal-core';
import { translationKeys } from '../../../enums/translations';
import { ResultImg } from '../../../components/checkHashPop/resultImg';

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const { data: thirdStepData, pending } = thirdStep;
  const { currencySymbolOrCode } = useUserInfoStore();
  const t = useTranslation();
  if (pending) {
    return <div />;
  }

  return (
    <div className='pgc-game-history-info-holder'>
      <div className='pgc-game-history-info-holder-middle'>
        <div className='g-h-result-wrp'>
          <div className='g-h-result-header'>
            <p className='g-h-result-header-text'>{t('RESULT')}</p>
          </div>
          <ResultImg dataForResultImage={thirdStepData} isFromResultHistory={false} />
        </div>
      </div>
      <div className='pgc-game-history-info-holder-bottom'>
        <div className='pgc-game-history-info-holder-bottom-header'>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p>{t(translationKeys.BetAmount)}</p>
          </div>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p>{t(translationKeys.Odd)}</p>
          </div>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p>{t(translationKeys.Win)}</p>
          </div>
        </div>
        <div className='pgc-game-history-info-holder-bottom-footer'>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p className='color-type3'>
              {thirdStepData.freeBetId
                ? `${t(translationKeys.FREE_BET)}`
                : `${thirdStepData.amount} ${currencySymbolOrCode}`}
            </p>
          </div>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p className='color-type2'>{`x${thirdStepData.odd}`}</p>
          </div>
          <div className='pgc-game-history-info-holder-bottom-header-txt-holder'>
            <p className='color-type2'>{`${thirdStepData.winAmount} ${currencySymbolOrCode}`}</p>
          </div>
        </div>
      </div>
    </div>
  );
});
